import React from "react";
import "../Evaluation.css";
import { useNavigate, useParams } from "react-router-dom";

const Selectchild = ({ Childlist }) => {
  const Navigate = useNavigate();
  const { school_id, id, type, child_id, qtype } = useParams();
  const BackHandler = () => {
    Navigate(
      `/classdetail/${school_id}/${type == "other" ? btoa("other") : id}`
    );
  };
  const Child_Handler = (childid) => {
    Navigate(`/evaluation/${school_id}/${id}/${type}/${childid}/1`);
  };
  return (
    <div className="w-3/12 border-r-2 h-full pt-2 max-[740px]:hidden">
      <button
        title="Back"
        onClick={BackHandler}
        className="text-3xl mx-3 text-[black] flex items-center"
      >
        {" "}
        <i class="fa-solid fa-arrow-left-long"></i>
      </button>
      <p className="font-semibold mb-1">Student evaluation</p>

      <div>
        {Childlist?.map((item, index) => {
          return (
            <div
              onClick={() => Child_Handler(btoa(item?.child_view_id))}
              key={index}
              className={`flex items-start border-b-2 p-2 cursor-pointer ${
                atob(child_id) == item?.child_view_id
                  ? "bg-[#fff4d4]"
                  : "bg-[transparent]"
              } hover:bg-[#ccc3] `}
            >
              <p className="mr-3 text-2xl text-[#0005]">
                <i className="fa-solid fa-user"></i>
              </p>
              <div>
                <p className="font-medium text-sm mb-1">{item?.child_name}</p>
                <p className="text-xs text-[#ccc]">{item?.child_standard}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Selectchild;
